export const EMAIL_REGEX = /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
export const PHONE_REGEX = /^[0-9]{11}$/;
export const NAME_REGEX = /^[a-zA-Z ,]*$/;
